import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js";
import { getOrgByRef } from "../../models/OrgFunctions.js";

import Divider from "../../layout/Divider.js";
import Icon1 from "../../icons/Icon.js";
import Space from "../../layout/Space.js";

import SecondaryButton from "../../buttons/SecondaryButton.js";

import PrimaryButton from "../../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import TextField2 from "../../textfields/TextField2.js";
import TextField2Password from "../../textfields/TextField2Password.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import sendInfiltreaTest from "../../api/infiltrea/sendInfiltreaTest.js";
import sendInfiltreaGenerateContacts from "../../api/infiltrea/sendInfiltreaGenerateContacts.js";
import sendInfiltreaResetContacts from "../../api/infiltrea/sendInfiltreaResetContacts.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import {
  getArrayDocDataByRef,
  queryCollection,
} from "../../models/DataFunctions.js";
import sendInfiltreaGetContacts from "../../api/infiltrea/sendInfiltreaGetContacts.js";
import { query } from "firebase/firestore";
import checkPageAccess, {
  checkPageAccessV2,
} from "../../auth/checkPageAccess.js";
import { EasySwitch, SaveBar } from "../../textfields/EasySwitch.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import MLTFGPT2 from "../../textfields/MLTFGPT2.js";
import MLTFGPT1 from "../../textfields/MLTFGPT1.js";
import MLTFGPTVA from "../../textfields/MLTFGPTVA.js";

const ATHSPE = ({ userData, orgData, navigateWorkspace, workspaceData }) => {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingData, setLoadingData] = useState(false);
  const [loadingData2, setLoadingData2] = useState(false);

  const [content, setContent] = useState(
    orgData.config?.athspe?.default_content ||
      "M/MME @nom,\nAtteste sur l’honneur qu’une collerette de conduit de poêle étanche à l’air sera installée, dans la maison de @nom située @adresse @postal @ville  pour être en accord avec la règlementation environnementale RE2020."
  );
  const [footer, setFooter] = useState(
    orgData.config?.athspe?.default_footer ||
      orgData.name +
        " " +
        orgData.infos?.phone +
        " " +
        orgData.infos?.email +
        " " +
        orgData.infos?.adresse +
        " " +
        orgData.infos?.postal +
        " " +
        orgData.infos?.ville
  );

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleSaveATHSPEdefault = async () => {
    setLoadingData2(true);
    try {
      await updateDocDataFieldApi(
        orgData.ref,
        "config.athspe.default_content",
        content,
        prefix
      );
      await updateDocDataFieldApi(
        orgData.ref,
        "config.athspe.default_footer",
        footer,
        prefix
      );
      handleClickVariant("Contenu de l'attestation enregistré", "success");
    } catch (error) {
      console.error("Error saving default ATHSPE content:", error);
      handleClickVariant("Erreur lors de l'enregistrement", "error");
    }
    setLoadingData2(false);
  };

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (userData) {
      try {
        if (
          (await checkPageAccessV2(
            userData,
            orgData,
            workspaceData,
            "basic"
          )) == false
        ) {
          navigateWorkspace("/home");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  if (loading || !currentUser || !userData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3">
        {/* Left Column Skeleton */}
        <Space y={20} />
        <div className="h-full flex-grow pl-4 flex flex-col gap-2 max-w-c1p2k">
          {/* Skeleton for the title and buttons */}
          <div className="flex flex-row w-full justify-between">
            <Skeleton variant="rounded" width={100} height={25} />

            <div className="flex flex-row gap-2">
              <Skeleton variant="rounded" width={100} height={25} />
              <Skeleton variant="rounded" width={100} height={25} />
            </div>
          </div>
          <Skeleton variant="rounded" width={200} height={30} />
          <Skeleton variant="rounded" width={100} height={25} />
          <Space y={10} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full pl-4 gap-2 pb-20 overflow-y-auto">
      {" "}
      <div className="text-h1 font-bold text-left">
        Attestations Spéciales à signer
      </div>
      <div className="text-h3 text-shadow_50 w-c600">
        Vous avez la possibilité de configurer les champs textes et le design
        des attestations spéciales à signer par vos clients.
      </div>
      <SaveBar
        condition={
          content !== orgData.config?.athspe?.default_content ||
          footer !== orgData.config?.athspe?.default_footer
        }
        onClick={handleSaveATHSPEdefault}
      />
      <DisplayATHSPE
        orgData={orgData}
        content={content}
        setContent={setContent}
        footer={footer}
        setFooter={setFooter}
      ></DisplayATHSPE>
    </div>
  );
};

export default ATHSPE;

export const DisplayATHSPE = ({
  orgData,
  content,
  setContent,
  footer,
  setFooter,
}) => {
  return (
    <div className="w-c600 flex flex-col text-h4 gap-0 p-4 bg-white rounded-3xl mt-6 shadow-lg border-1 border-shadow_10">
      <div className="flex flex-row gap-2 items-start justify-between  text-black">
        <div className="text-black font-semibold text-hx">
          Attestation à signer sur l'honneur
        </div>
        <img src={orgData.logo} className="w-fit rounded-md h-10" />
      </div>
      <div className="flex flex-row gap-2 mt-4 items-center  text-black">
        <div className="w-c200">Numéro d'attestation</div>{" "}
        <div className="w-c200">54516521-0019</div>
      </div>{" "}
      <div className="flex flex-row gap-2 items-center mb-4 text-shadow_50">
        <div className="w-c200">Date d'émission</div>{" "}
        <div className="w-c200">14/05/2025</div>
      </div>
      <MLTFGPT1
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={8}
      ></MLTFGPT1>
      <div className="flex flex-col text-h4 gap-1 items-end w-full mt-4 mb-8 ">
        <div className="w-c200">Fait à {orgData.infos.ville},</div>{" "}
        <div className="w-c200">Le 14/05/2025</div>
        <div className="border-1 border-black w-c200 h-c100 mt-2">
          <div className="bg-black p-1 text-white">Signature</div>
        </div>{" "}
        <div className="border-1  border-black w-c200 h-c100">
          <div className="bg-black p-1 text-white">Cachet de l'entreprise</div>
        </div>
      </div>{" "}
      <MLTFGPT1
        value={footer}
        onChange={(e) => setFooter(e.target.value)}
        rows={2}
        className="text-h4"
      ></MLTFGPT1>
    </div>
  );
};
